import {Injectable} from '@angular/core';
import {DrawModes, EditorControls} from '../../Utils/Objects/events';
import {ContainerService} from '../../Utils/container.service';
import {CameraService} from '../../3DView/Scene/camera.service';
import {Subject} from 'rxjs';
import {SceneService} from '../../3DView/Scene/scene.service';
import {RenderService} from '../../3DView/Scene/render.service';
import {ObjectUtilsService} from '../../3DView/object-utils.service';
import {CanvasControl} from '../../3DView/Control/controls';
import {OrbitControlsService} from '../../3DView/Control/orbit-controls.service';

@Injectable({
    providedIn: 'root'
})
export class EditorControlService {

    public ctrl = new Subject<string>();

    // get/set
    private _event: EditorControls;
    public  _customControls = new Map<string, CanvasControl>();
    private _customEvent: string;

    constructor(private orbitControlsService: OrbitControlsService,
                private containerService: ContainerService,
                private cameraService: CameraService,
                private modelOperationsService: ObjectUtilsService,
                private sceneService: SceneService,
                private renderService: RenderService) {
        this.initControl();
    }

    public initControl() {
        this.ctrl.subscribe(value => {
            if (this._customControls.has(value)) {
                if (value !== this.customEvent) {
                    const customControl = this._customControls.get(this._customEvent);
                    customControl?.finish?.();
                }
                this._customEvent = value;
                this.editorControls = EditorControls.custom;
            } else if (EditorControls[value]) {
                this.editorControls = EditorControls[value];
                // TODO usage-check
                // this.containerService.paintMode = JSON.parse(DrawModes[this.eventType]);
            } else {
                throw Error('Invalid control option: Ensure the name contains no spelling errors' +
                            'or is registered in the case of custom events.');
            }
        });
    }

    get eventType(): any {
        return EditorControls[this.event];
    }

    get event(): EditorControls {
        return this._event;
    }

    get customControls(): ReadonlyMap<string, CanvasControl> {
        return this._customControls;
    }

    get customEvent(): string {
        return this._customEvent;
    }

    private set editorControls(value: EditorControls) {
        this._event = value;

        // TODO: check if everything works correctly
        // switch (this._event) {
        //     case EditorControls.drawOnPoly:
        //     case EditorControls.drawAll:
        //     case EditorControls.drawOnPolyRect:
        //         this.orbitControlsService.controlMode = false;
        //         this.orbitControlsService.changeControlMode(true);
        //         this.containerService.bufferScene = new Scene();
        //         this.containerService.bufferScene.add(this.containerService.polyPaintGroup);
        //         break;
        //
        //         break;
        //     default:
        //         break;
        //
        // }

        const control = this._customControls.get(this._customEvent);

        this.orbitControlsService.changeControlMode((control.zoom ?? true) ||
            (control.rotate ?? true));
        this.orbitControlsService.controlMode = control.controlMode ?? true;

        if (this.orbitControlsService.orbitControls) {
            this.orbitControlsService.orbitControls.enableZoom = control.zoom ?? true;
            this.orbitControlsService.orbitControls.enableRotate = control.rotate ?? true;
        }
        control.init?.();
    }


    /**
     * Resets the orbitcontrols.
     */
    public resetOrbitControls() {
        this.orbitControlsService.orbitControls.reset();
    }

    public registerControl(name: string, control: CanvasControl) {
        this._customControls.set(name, control);
    }

    public unregisterControl(name: string): boolean {
        return this._customControls.delete(name);
    }

    // -------------------------------------------------------------------------------------------------------------------------------------

}
